<template>
	<!-- <section>
		<div class="t-body3 mgt-8 t-color-bodyGrayA" v-html="$t('64', {str1: '', str2: `<span class='t-color-headlineBlack'><strong>${findId.loginId}</strong></span>`})">
		</div>
		<div class="mgt-50">
			<button class="mdc-button mdc-button--raised btn-red w-full btn-big" @click="$moveLogin()">
				{{$t('65')}}
			</button>
		</div>
	</section> -->
	<div>
			<div class="t-headline10 font-b mgb-8 pdl-24 pdr-24">{{$t('1')}}</div>
				<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24" v-html="$t('64', {str1: `<span class='t-color-headlineBlack font-b'><strong>${$t('3437',{first: findId.loginName.first, last: findId.loginName.last})}</strong></span>`, str2: `<span class='t-color-headlineBlack font-b'><strong>${findId.loginId}</strong></span>`})">

				</div>
				<div class="mgt-50 pdl-24 pdr-24 mgb-50">
					<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText w-full b-radius4" @click="goToPrevious()" @keypress="goToPrevious()" tabindex="0">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{$t('65')}}</span>
					</button>
				</div>
	</div>
</template>

<script>
/**
 * 계정 찾기 완료 컴포넌트 (find account complete component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import {mapState} from 'vuex'
import {findIdMixin} from "@/mixins/findId";

export default {
  mixins: [findIdMixin],

  computed: {
		...mapState('findId',{
			findId : state => state,
		}),
	},

	mounted() {
		this.setMaterialUi()
	},

	methods: {
    goToPrevious() {
      this.pathName ? this.$moveLogin() : this.$moveBrandSelect();
    },

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	},
}
</script>
